"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Slider = _interopRequireDefault(require("./Slider"));
var _useQuestionSelectionActions = require("../../hooks/questionnaire/useQuestionSelectionActions");
var _RangePicker = _interopRequireDefault(require("./RangePicker/RangePicker"));
var _constants = require("../../utils/constants");
var _services = require("../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var getSliderProps = function getSliderProps(rangeData, selection) {
  var rangeTitle = rangeData.rangeTitle,
    rangeChoices = rangeData.rangeChoices;
  var min = rangeChoices.min,
    max = rangeChoices.max,
    step = rangeChoices.step,
    minLabel = rangeChoices.minLabel,
    maxLabel = rangeChoices.maxLabel;
  var value = selection || min;
  var title = rangeTitle.replace('{{value}}', value).replace('{{currencyValue}}', _services.locale.formatPrice(value, {
    fraction: false
  }));
  var labels = rangeChoices.labels;
  if (!labels) {
    labels = [{
      value: min,
      label: minLabel
    }, {
      value: max,
      label: maxLabel
    }];
    for (var i = min + step; i <= max - step; i += step) {
      labels.push({
        value: i,
        label: i
      });
    }
    labels.sort(function (l1, l2) {
      return l1.value - l2.value;
    });
  }
  return {
    title: title,
    value: value,
    min: min,
    max: max,
    step: step,
    labels: labels
  };
};
var QuestionWithRange = function QuestionWithRange(_ref) {
  var question = _ref.question,
    onUpdate = _ref.onUpdate,
    _ref$selections = _ref.selections,
    selections = _ref$selections === void 0 ? [] : _ref$selections,
    _ref$selectionIndex = _ref.selectionIndex,
    selectionIndex = _ref$selectionIndex === void 0 ? 0 : _ref$selectionIndex,
    componentIndex = _ref.componentIndex;
  var rangeProps = getSliderProps(question, selections[selectionIndex]);
  var _useQuestionSelection = (0, _useQuestionSelectionActions.useQuestionSelectionActions)(question),
    replaceSelection = _useQuestionSelection.replaceSelection;
  var onChangeValue = function onChangeValue(selection) {
    replaceSelection(selection, selectionIndex);
    if (typeof onUpdate === 'function') {
      onUpdate(selection);
    }
  };
  if (selections.length === 0 && question.viewType !== _constants.QUESTION_VIEW_TYPE.CHOICES) {
    (0, _react.useEffect)(function () {
      replaceSelection(rangeProps.value, selectionIndex);
    }, []);
  }
  var idPrefix = componentIndex !== undefined ? "set-".concat(componentIndex, "-") : '';
  var icon = question.rangeIcon;
  switch (question.viewType) {
    case _constants.QUESTION_VIEW_TYPE.CHOICES:
      return /*#__PURE__*/_react.default.createElement(_RangePicker.default, {
        icon: icon,
        onChangeValue: onChangeValue,
        choices: rangeProps.labels,
        title: rangeProps.title,
        selection: selections[selectionIndex],
        idPrefix: idPrefix
      });
    default:
      return /*#__PURE__*/_react.default.createElement(_Slider.default, _extends({}, rangeProps, {
        icon: icon,
        onChangeValue: onChangeValue,
        idPrefix: idPrefix
      }));
  }
};
var _default = QuestionWithRange;
exports.default = _default;